import { api } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  getCustomerList(page, q = '', sort_by = 'first_name asc', limit = '10') {
    const params = {
      cursor: page,
      limit,
      q,
      sort_by,
    };
    const url = '/users';
    return api.get(url, { params: omitBy(params, isNil) });
  },
  getCustomerDetail(id) {
    return api.get(`/users/${id}`);
  },
  getCustomerWallet({ id, cursor, start_date, end_date } = {}) {
    const params = {
      cursor,
      end_date,
      limit: 10,
      start_date,
    };
    return api.get(`/users/${id}/wallet`, { params: omitBy(params, isNil) });
  },
  topUpWallet(id, payload) {
    return api.post(`/users/${id}/wallet/disburse`, payload);
  },
  bulkTopUp(payload) {
    return api.post('/users/wallet/bulk_disburse', payload);
  },
  getCustomerReport({ q = '', sort_by = 'email asc' }) {
    const params = {
      q,
      sort_by,
    };
    const url = '/users/user_report';
    return api.get(url, { params: omitBy(params, isNil) });
  },
  getCustomerGlobalWallet({
    activity,
    cursor,
    end_date,
    limit,
    sort_by = 'created_at desc',
    start_date,
  } = {}) {
    const params = {
      activity,
      cursor,
      end_date,
      limit,
      sort_by,
      start_date,
    };
    const url = '/users/wallet_activities';
    return api.get(url, { params: omitBy(params, isNil) });
  },
  getGlobalCustomerWalletReport() {
    return api.get('users/wallet_activities_report');
  },
};
